import { actionCreator } from "./helpers";
import { callApi } from "./Api";

export const SEGMENT_SUMMARY = "SEGMENT_SUMMARY";
export const SEGMENT_COUNTS = "SEGMENT_COUNTS";
export const SEGMENT_ATTR_COUNTS = "SEGMENT_ATTR_COUNT";
export const CLEAR_SEGMENT_SUMMARY = "CLEAR_SEGMENT_SUMMARY";
export const CLEAR_SEGMENT_ATTR_COUNTS = "CLEAR_SEGMENT_ATTR_COUNTS";
export const REQUEST_ACTIVATION = "REQUEST_ACTIVATION";

export const clearSegmentSummary = actionCreator(CLEAR_SEGMENT_SUMMARY);
export const clearSegmentSegmentAttrCounts = actionCreator(
  CLEAR_SEGMENT_ATTR_COUNTS,
);

export const fetchSegmentSummary = id => {
  const url = `segments/${id}/with-rules`;
  return (dispatch, getState) => {
    callApi(dispatch, getState, SEGMENT_SUMMARY, url);
  };
};

export const getSegmentCounts = id => {
  const url = `segments/${id}/counts`;
  return (dispatch, getState) => {
    callApi(dispatch, getState, SEGMENT_COUNTS, url);
  };
};

export const getSegmentRulesCounts = (rules, sid) => {
  const url = sid
    ? `segments/attribute-counts?sid=${sid}`
    : `segments/attribute-counts`;
  return (dispatch, getState) => {
    callApi(dispatch, getState, SEGMENT_ATTR_COUNTS, url, {
      method: "POST",
      body: JSON.stringify(rules),
    });
  };
};

export const requestActivation = (id, clientId, subject, comment) => {
  const url = `segments/${id}/request-activation`;
  const postData = {
    clientId: clientId,
    subject: subject,
    comment: comment,
  };
  return (dispatch, getState) => {
    callApi(dispatch, getState, REQUEST_ACTIVATION, url, {
      method: "POST",
      body: JSON.stringify(postData),
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/SegmentDetail.js